<template>
  <v-content>
    <v-container>
      <list
        v-show="!loading"
        :title="title"
        :headers="headers"
        :data="data"
        :response="response"
        :loading="loading"
        :show-add-new="false"
        :show-pagination="false"
        :show-search="false"
        @reload="loadDealers"
        @details="handleDetails"
      ></list>
    </v-container>
  </v-content>
</template>
<script>
import { mapGetters } from "vuex";
import api from "@/utils/api.js";
import i18n from "@/utils/translations";
import List from "@/components/lists/BuilderList.vue";
export default {
  components: {
    List,
  },
  data: () => ({
    headers: [],
    title: "",
    data: [],
    response: null,
    loading: true,
  }),
  created() {
    this.setInitalData();

    if (this.getMe.dealerships.length > 0) {
      this.loadDealers();
    } else {
      console.error("BILLINGS: User does not have any partners, rerouting");
      this.$router.push({ name: "base" });
    }
  },
  computed: {
    ...mapGetters(["getMe", "getLinks", "getTheme", "getNonValidDealerships"]),
  },

  methods: {
    loadDealers(params) {
      this.loading = true;
      this.data = [];
      params = { ...params, my_account: true };
      api.getDealerList(params).then((resp) => {
        this.response = resp.data;
        this.data = resp.data.results.map((item) => {
          return {
            ...item,
            licence: !this.getNonValidDealerships
              .map((dealership) => dealership.id)
              .includes(item.uuid)
              ? { icon: "mdi-check-circle", color: "gray" }
              : { icon: "mdi-alert", color: "orange" },
          };
        });

        if (this.data.length === 1) {
          this.handleDetails(this.data[0]);
        }

        this.loading = false;
      });
    },
    setInitalData() {
      this.headers = [
        {
          text: this.$t("users.dealers.name"),
          align: "left",
          sortable: false,
          value: "name",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.brands"),
          align: "left",
          value: "brands",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.users"),
          align: "left",
          value: "user_count",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.country"),
          align: "left",
          value: "country",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.city"),
          align: "left",
          value: "city",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.licence"),
          align: "left",
          value: "licence",
          canHide: true,
        },
      ];

      this.title = this.$t("general.billings.subscriptions");
    },
    handleDetails(dealer) {
      this.$router.push({ name: "billing", params: { id: dealer.uuid } });
    },
  },
};
</script>
<style scoped>
.fill-screen {
  height: 100vh;
}
</style>
